import { StandardEvents } from '@shopify/events';

export function estimateDelivery(now, minDays, maxDays) {
  if (!(now instanceof Date) || Number.isNaN(now.getTime()) || !Number.isInteger(minDays) || !Number.isInteger(maxDays) || minDays < 1 || maxDays < minDays) return null;
  const parts = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Australia/Perth', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hourCycle: 'h23'
  }).formatToParts(now);
  const value = (type) => Number(parts.find((part) => part.type === type).value);
  const start = new Date(Date.UTC(value('year'), value('month') - 1, value('day'), 12));
  const isWeekend = (date) => date.getUTCDay() === 0 || date.getUTCDay() === 6;
  if (value('hour') >= 17) start.setUTCDate(start.getUTCDate() + 1);
  while (isWeekend(start)) start.setUTCDate(start.getUTCDate() + 1);
  const addBusinessDays = (count) => {
    const date = new Date(start);
    while (count > 0) {
      date.setUTCDate(date.getUTCDate() + 1);
      if (!isWeekend(date)) count -= 1;
    }
    return date;
  };
  return [addBusinessDays(minDays), addBusinessDays(maxDays)];
}

if (typeof window !== 'undefined' && !customElements.get('case-delivery-estimate')) {
  customElements.define('case-delivery-estimate', class extends HTMLElement {
    static observedAttributes = ['data-country', 'data-locale', 'data-min-days', 'data-max-days'];

    connectedCallback() {
      this.renderEstimate();
      this.stockGeneration = 0;
      this.productSection = this.closest('.product-information');
      this.onProductSelect = async (event) => {
        const generation = ++this.stockGeneration;
        this.setStock(false);
        try {
          const { detail } = await event.promise;
          if (this.isConnected && generation === this.stockGeneration) this.setStock(Boolean(detail?.resource?.available));
        } catch {
          if (this.isConnected && generation === this.stockGeneration) this.setStock(false);
        }
      };
      this.productSection?.addEventListener(StandardEvents.productSelect, this.onProductSelect);
      this.onVisibility = () => this.renderEstimate();
      document.addEventListener('visibilitychange', this.onVisibility);
      this.timer = window.setInterval(() => this.renderEstimate(), 60 * 1000);
    }

    disconnectedCallback() {
      document.removeEventListener('visibilitychange', this.onVisibility);
      this.productSection?.removeEventListener(StandardEvents.productSelect, this.onProductSelect);
      this.stockGeneration += 1;
      window.clearInterval(this.timer);
    }

    setStock(available) {
      const status = this.querySelector('[data-stock-status]');
      if (status) status.hidden = !available;
    }

    attributeChangedCallback() {
      if (this.isConnected) this.renderEstimate();
    }

    renderEstimate() {
      const target = this.querySelector('[data-arrival-window]');
      const now = new Date();
      const dates = estimateDelivery(now, Number(this.dataset.minDays), Number(this.dataset.maxDays));
      if (!target || !dates) return;
      const locale = ({ US: 'en-US', AU: 'en-AU', GB: 'en-GB', CA: 'en-CA', NZ: 'en-NZ' })[this.dataset.country] || this.dataset.locale || 'en';
      const options = { month: 'short', day: 'numeric', timeZone: 'UTC' };
      if (dates[0].getUTCFullYear() !== dates[1].getUTCFullYear() || dates[1].getUTCFullYear() !== now.getFullYear()) options.year = 'numeric';
      const formatter = new Intl.DateTimeFormat(locale, options);
      const range = document.createElement('span');
      range.className = 'case-delivery__dates';
      range.textContent = `${formatter.format(dates[0])} – ${formatter.format(dates[1])}`;
      target.replaceChildren(document.createTextNode(`${this.dataset.prefix} `), range);
    }
  });
}
